module.exports = __webpack_public_path__ + "img/pdf.bdeccdde.svg";